import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-2" }
const _hoisted_2 = { class: "text-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: _normalizeClass([_ctx.containerClasses, "text-center mb-2 bg-red-darken-3"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", {
          class: _normalizeClass(_ctx.titleClasses)
        }, "Q&A", 2),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.subtitleClasses)
        }, " Antworten auf häufige Fragen ", 2)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.simpleFaq, (item, index) => {
        return (_openBlock(), _createBlock(_component_v_expansion_panels, {
          accordion: "",
          class: _normalizeClass([[_ctx.columnClasses, _ctx.responsiveWidth], "mt-4 mx-auto"]),
          key: index
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel, { class: "rounded-s-shaped elevation-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, {
                  class: _normalizeClass([[_ctx.bodyTextClasses], "bg-red-lighten-5 font-weight-bold"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.question), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]),
                _createVNode(_component_v_expansion_panel_text, {
                  class: _normalizeClass([[_ctx.bodyTextClasses], "bg-grey-lighten-5 text-left"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.answer), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, {
          text: "",
          color: "primary",
          class: "mt-2",
          size: _ctx.buttonSize
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Mehr Fragen? Kontaktiere mich ", -1)
          ]))]),
          _: 1
        }, 8, ["size"])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}